/** A display/cache boundary only; the server verifies the token and membership. */
export function tokenScope(token: string | null): { userId: string; tenantId: string } | null {
  if (!token) return null;
  try {
    const encoded=token.split(".")[1];
    const payload=JSON.parse(atob(encoded.replace(/-/g,"+").replace(/_/g,"/")));
    return typeof payload.sub==="string" && typeof payload.tid==="string" ? {userId:payload.sub,tenantId:payload.tid} : null;
  } catch { return null; }
}
export function sameTokenScope(first: string | null, second: string | null): boolean {
  if(first===second)return true;
  const a=tokenScope(first),b=tokenScope(second);
  return !!a && !!b && a.userId===b.userId && a.tenantId===b.tenantId;
}
